import { HttpHeaders } from '@angular/common/http';

export const HEADERS = {
  formUrlEncoded: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  }),
  formUrlEncodedNoCharset: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
  }),
  json: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};
